const Maintenance = () => {
  return (
    <section className='container'>
      <h1>Disculpe las molestias, el sitio se encuentra en mantenimiento.</h1>
    </section>
  )
}

export default Maintenance
